// import React, { useState, useEffect } from "react";
// import AdminAppBody from "../../../../components/admin/AdminAppBody";
// import PageHeading from "../../../../components/admin/common/PageHeading";
// import useApiCallHooks from "../../../../hooks/useApiCallHooks";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import { uiRoutes } from "../../../../routes/ui/uiRoutes";

// // ✅ Froala imports
// import FroalaEditor from "react-froala-wysiwyg";
// import "froala-editor/css/froala_editor.pkgd.min.css";
// import "froala-editor/css/froala_style.min.css";

// const AddCaseStudy = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     image: null,
//     live_url: "",
//     description: "",
//   });

//   const [imagePreview, setImagePreview] = useState(null);
//   const navigate = useNavigate();
//   const [response, loading, error, callAPI, statusCode] = useApiCallHooks();

//   useEffect(() => {
//     if (response?.data && statusCode === 201) {
//       toast.success("Case Study added successfully!");
//       setTimeout(() => {
//         navigate(uiRoutes.admin.casestudy.list); // redirect to list
//       }, 1000);
//     }
//   }, [response, statusCode, navigate]);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const submitData = new FormData();
//     Object.keys(formData).forEach((key) => {
//       submitData.append(key, formData[key]);
//     });
//     callAPI("post", "admin/case-studies", submitData);
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     setFormData({ ...formData, image: file });
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setImagePreview(reader.result);
//       };
//       reader.readAsDataURL(file);
//     } else {
//       setImagePreview(null);
//     }
//   };

//   return (
//     <AdminAppBody
//       loading={loading}
//       content={
//         <div className="container mt-5">
//           <PageHeading
//             title="Add Case Study"
//             subTitle="Fill out the details of case studies"
//           />
//           <div className="container card p-4 shadow-sm mt-3">
//             <form
//               onSubmit={handleSubmit}
//               className="row g-3"
//               encType="multipart/form-data"
//             >
//               <h6 className="">Add Case Study Form</h6>

//               {/* Name */}
//               <div className="col-md-4">
//                 <label className="form-label">Name</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={formData.name}
//                   onChange={(e) =>
//                     setFormData({ ...formData, name: e.target.value })
//                   }
//                 />
//                 <span className="val-message text-danger">
//                   {error?.message === "ValidationError" && error?.data?.name}
//                 </span>
//               </div>

//               {/* Live URL */}
//               <div className="col-md-4">
//                 <label className="form-label">Live URL</label>
//                 <input
//                   type="url"
//                   className="form-control"
//                   value={formData.live_url}
//                   onChange={(e) =>
//                     setFormData({ ...formData, live_url: e.target.value })
//                   }
//                 />
//                 <span className="val-message text-danger">
//                   {error?.message === "ValidationError" &&
//                     error?.data?.live_url}
//                 </span>
//               </div>

//               {/* Image Upload */}
//               <div className="col-md-4">
//                 <label className="form-label">Image Upload</label>
//                 <input
//                   type="file"
//                   accept="image/*"
//                   className="form-control"
//                   onChange={handleImageChange}
//                 />
//                 {imagePreview && (
//                   <img
//                     src={imagePreview}
//                     alt="Preview"
//                     className="mt-2"
//                     style={{
//                       width: "100%",
//                       maxHeight: "200px",
//                       objectFit: "contain",
//                     }}
//                   />
//                 )}
//                 <span className="val-message text-danger">
//                   {error?.message === "ValidationError" && error?.data?.image}
//                 </span>
//               </div>

//               {/* Description with Froala */}
//               <div className="col-md-12">
//                 <label className="form-label">Description</label>
//                 <div className="border rounded p-2 bg-white">
//                   <FroalaEditor
//                     model={formData.description}
//                     onModelChange={(val) =>
//                       setFormData({ ...formData, description: val })
//                     }
//                   />
//                 </div>
//                 <span className="val-message text-danger">
//                   {error?.message === "ValidationError" &&
//                     error?.data?.description}
//                 </span>
//               </div>

//               {/* Submit Button */}
//               <div className="col-4 mt-5 mb-5">
//                 <button type="submit" className="btn btn-primary w-100">
//                   Submit
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       }
//     />
//   );
// };

// export default AddCaseStudy;


import React, { useState, useEffect } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { uiRoutes } from "../../../../routes/ui/uiRoutes";

// ✨ DraftJS Imports
import { EditorState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"; // Editor styles

const AddCaseStudy = () => {
  const [formData, setFormData] = useState({
    name: "",
    image: null,
    live_url: "",
    description: "",
  });

  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [imagePreview, setImagePreview] = useState(null);
  const navigate = useNavigate();
  const [response, loading, error, callAPI, statusCode] = useApiCallHooks();

  useEffect(() => {
    if (response?.data && statusCode === 201) {
      toast.success("Case Study added successfully!");
      setTimeout(() => {
        navigate(uiRoutes.admin.casestudy.list);
      }, 1000);
    }
  }, [response, statusCode, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Convert editorState to HTML
    const htmlDescription = draftToHtml(convertToRaw(editorState.getCurrentContent()));

    const submitData = new FormData();
    submitData.append("name", formData.name);
    submitData.append("live_url", formData.live_url);
    submitData.append("description", htmlDescription);
    if (formData.image) {
      submitData.append("image", formData.image);
    }

    callAPI("post", "admin/case-studies", submitData);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFormData({ ...formData, image: file });
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    } else {
      setImagePreview(null);
    }
  };

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container mt-5">
          <PageHeading
            title="Add Case Study"
            subTitle="Fill out the details of case studies"
          />
          <div className="container card p-4 shadow-sm mt-3">
            <form
              onSubmit={handleSubmit}
              className="row g-3"
              encType="multipart/form-data"
            >
              <h6 className="">Add Case Study Form</h6>

              {/* Name */}
              <div className="col-md-4">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                />
                <span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.name}
                </span>
              </div>

              {/* Live URL */}
              <div className="col-md-4">
                <label className="form-label">Live URL</label>
                <input
                  type="url"
                  className="form-control"
                  value={formData.live_url}
                  onChange={(e) =>
                    setFormData({ ...formData, live_url: e.target.value })
                  }
                />
                <span className="val-message text-danger">
                  {error?.message === "ValidationError" &&
                    error?.data?.live_url}
                </span>
              </div>

              {/* Image Upload */}
              <div className="col-md-4">
                <label className="form-label">Image Upload</label>
                <input
                  type="file"
                  accept="image/*"
                  className="form-control"
                  onChange={handleImageChange}
                />
                {imagePreview && (
                  <img
                    src={imagePreview}
                    alt="Preview"
                    className="mt-2"
                    style={{
                      width: "100%",
                      maxHeight: "200px",
                      objectFit: "contain",
                    }}
                  />
                )}
                <span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.image}
                </span>
              </div>

              {/* Description with React Draft WYSIWYG */}
              <div className="col-md-12">
                <label className="form-label">Description</label>
                <div className="border rounded bg-white p-2">
                  <Editor
                    editorState={editorState}
                    onEditorStateChange={setEditorState}
                    wrapperClassName="demo-wrapper"
                    editorClassName="demo-editor"
                    toolbar={{
                      options: [
                        "inline",
                        "blockType",
                        "fontSize",
                        "list",
                        "textAlign",
                        "colorPicker",
                        "link",
                        "embedded",
                        "remove",
                        "history",
                      ],
                    }}
                  />
                </div>
                <span className="val-message text-danger">
                  {error?.message === "ValidationError" &&
                    error?.data?.description}
                </span>
              </div>

              {/* Submit Button */}
              <div className="col-4 mt-5 mb-5">
                <button type="submit" className="btn btn-primary w-100">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      }
    />
  );
};

export default AddCaseStudy;
